import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
if (!BACKEND_URL) {
  console.error("[api] REACT_APP_BACKEND_URL is not set — API calls will fail. Set the secret in GitHub and redeploy.");
}
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("gl_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const imgUrl = (assetId) => {
  if (!assetId) return "";
  const t = localStorage.getItem("gl_token");
  if (!t) return ""; // no token — don't make a request that will 401
  return `${API}/images/${assetId}/download?auth=${encodeURIComponent(t)}`;
};
